import React from "react";
import { shallowEqual, useSelector } from "react-redux";

import { isSku } from "@utils/general";

import { getQuery } from "@redux/modules/value/search/search.selectors";

import { SearchTitleComponent } from "./searchTitle.component";

const SearchTitle = () => {
    const query = useSelector(getQuery, shallowEqual);

    const firstQuery = query.split(" ").at(0);
    const hideTitle = firstQuery && isSku(firstQuery);

    if (hideTitle) return null;
    return <SearchTitleComponent query={query} />;
};

export { SearchTitle };
